import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  InputGroup,
  Form,
  Table,
} from "react-bootstrap";
import {
  FaPlus,
  FaCog,
  FaFilter,
  FaRedo,
  FaSearch,
  FaSort,
  FaToggleOff,
  FaToggleOn,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import {
  getSitesList,
  updateStiteStatus,
  deleteSite,
} from "../../services/Organization-services.js";
import { getMethods } from "../../services/utilityFunctions";
import MasterTable from "../../views/dashboard/widget/MasterTabel";
import AddSiteForm from "../../components/FormComponents/AddSite";

import { useGlobalState } from "../../services/hostelConst";
const SitesTable = () => {
  const { _advanceFilterList, updateAdvanceFilterList } = useGlobalState();
  useEffect(() => {
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    return () => {};
  }, []);
  return (
    <>
      <MasterTable
        getTableData={getSitesList}
        tab1={"Organization"}
        tab2={"Sites"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
        updateStatus={updateStiteStatus}
        AddForm={AddSiteForm}
        deleteRow={deleteSite}
      />
    </>
  );
};

export default SitesTable;
